import { sortStr } from '@utils/sorting/non-ascii';
import { sortByOther } from '@utils/sorting/sortByOther';

export const categOrder: EquipmentStatusCategoryOptions[] = [
  'Online',
  'Offline',
  'Decommissioned',
];
export const equipmentStatusCategoryOptions = <const>[
  'Online',
  'Offline',
  'Decommissioned',
];
export type EquipmentStatusCategoryOptions =
  typeof equipmentStatusCategoryOptions[number];

export interface IEquipmentStatus {
  id: string;
  name: string;
  description: string | null;
  category: EquipmentStatusCategoryOptions;
  studioConfigurationId: string;
  isDefault: boolean;
}

export interface IEquipmentStatusApiModel {
  id: string;
  name: string;
  description: string | null;
  category: EquipmentStatusCategoryOptions;
  studioConfigurationId: string;
  isDefault: boolean;
}
// Todo: Update mass edit model for equipmentstatus
export interface IEquipmentStatusApiModel2 {
  // These can't be null right?
  id: string;
  name: string;
  category: EquipmentStatusCategoryOptions;
}
export default class EquipmentStatus implements IEquipmentStatus {
  public readonly id: string;

  public readonly name: string;

  public readonly description: string | null;

  public readonly studioConfigurationId: string;

  public readonly category: EquipmentStatusCategoryOptions;

  public readonly isDefault: boolean;

  constructor(
    id: string,
    name: string,
    description: string | null,
    category: EquipmentStatusCategoryOptions,
    studioConfigurationId: string,
    isDefault: boolean,
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.studioConfigurationId = studioConfigurationId;
    this.category = category;
    this.isDefault = isDefault;
  }

  static createEmpty(): IEquipmentStatus {
    return new EquipmentStatus('', '', null, 'Online', '', false);
  }

  static fromApiModel(apiModel: IEquipmentStatusApiModel): IEquipmentStatus {
    const {
      id,
      name,
      description,
      category,
      studioConfigurationId,
      isDefault,
    } = apiModel;

    return new EquipmentStatus(
      id,
      name,
      description,
      category,
      studioConfigurationId,
      isDefault,
    );
  }

  static arrayFromApiModel(arrayApiModel: IEquipmentStatusApiModel[]) {
    const array = arrayApiModel.map(apiModel =>
      EquipmentStatus.fromApiModel(apiModel),
    );
    // sort by name then category
    array.sort((a, b) => sortStr(a.name, b.name));

    array.sort((a, b) => sortByOther(categOrder, a.category, b.category));
    return array;
  }
}
